<template>
  <div class='leak-type-table-cell'>
    <span class="value" :title='value'>{{value}}</span>
  </div>
</template>

<script>
export default {
  name: 'LeakTypeTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    value() {
      return this.item[this.column.field];
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.leak-type-table-cell {
  display: flex;
  align-items: center;
  max-width: 100%;
  .value {
    z-index: 3;
    color: var(--text-primary);
    font-family: $font-family-regular;
    font-size: rem(14);
    letter-spacing: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: break-spaces;
    -webkit-line-clamp: 3;
    line-height: 1.2em;
  }
  .empty {
    color: var(--text-secondary);
  }
}
</style>
